import React from 'react';
import { fill, percentage } from './labels';

export default function CompanyProgress({ companies, activeCount, labels }) {
  var rows = companies || [];
  // The design's "23 aktif" counts every company scheduled today, not the
  // truncated top-N this card lists.
  var total = typeof activeCount === 'number' ? activeCount : rows.length;

  return (
    <div className="card ehc-monitoring__card">
      <div className="card-header ehc-monitoring__card-header">
        <span className="ehc-monitoring__eyebrow">{labels.eyebrow}</span>
        <span className="ehc-monitoring__count">{fill(labels.count, { count: total })}</span>
      </div>
      <div className="card-body">
        {rows.length === 0 && <p className="text-muted mb-0">{labels.empty}</p>}

        {rows.map(function (company) {
          var pct = percentage(company.complete, company.scheduled);

          return (
            <div className="ehc-monitoring__company" key={company.id}>
              <div className="ehc-monitoring__company-top">
                <span className="ehc-monitoring__company-name">{company.name}</span>
                <span className="ehc-monitoring__company-ratio">
                  {company.complete}/{company.scheduled}
                </span>
              </div>
              <div className="progress ehc-monitoring__progress">
                <div
                  className={'progress-bar ehc-monitoring__progress-bar ehc-monitoring__progress-bar--w-' +
                    Math.round(pct / 5) * 5}
                  role="progressbar"
                  aria-valuenow={pct}
                  aria-valuemin="0"
                  aria-valuemax="100"
                />
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
